import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CreateMultiResponseQuesConfigRequestMutation = gql`
  mutation createMultiResponseQuesConfigRequestMutation(
    $maxResponse: Int!
    $minResponse: Int!
    $projectId: String!
    $description: String!
  ) {
    questionConfiguration {
      createQuestionConfiguration(
        baseConfiguration: { projectId: $projectId, description: $description }
        questionConfigurationMultiResponseText: {
          type: FREE_TEXT
          maxResponse: $maxResponse
          minResponse: $minResponse
        }
      ) {
        id
        ... on MultiResponseText {
          id
          maxResponse
          minResponse
          type
        }
      }
    }
  }
`;

const createMultiResponseQuesConfigRequest = ({
  minResponses,
  maxResponses,
  projectId,
  description,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CreateMultiResponseQuesConfigRequestMutation}>
    {(createAppVersion, { loading, error, data }) => {
      const variables = {
        maxResponse: maxResponses,
        minResponse: minResponses,
        projectId,
        description,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(
          data.questionConfiguration.createQuestionConfiguration.id
        );
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createAppVersion}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createMultiResponseQuesConfigRequest.propTypes = {
  description: PropTypes.string.isRequired,
  maxResponses: PropTypes.number.isRequired,
  minResponses: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
};

createMultiResponseQuesConfigRequest.defaultProps = {};

export default createMultiResponseQuesConfigRequest;
